import { useEffect, useState } from "react";
import blogData from "../backend/blogdata.json";
import BlogCard from "./BlogCard";

const AllBlogs = () => {
    
    window.scrollTo(0, 0);

    const [isFilter, setIsFilter] = useState("all");
    const [isblogCount, setBlogCount] = useState(Object.keys(blogData).length);
    const [tags, setTags] = useState([]);
    const activeClass = "bg-black text-white cursor-default dark:bg-white dark:text-black";

    const updateBlogCount = (category) => {
        setBlogCount(Object.keys(blogData).filter(row => blogData[row].tags.includes(category)).length);
    }

    const fetchTags = () => {
        const uniqueTagsSet = new Set();

        Object.values(blogData).forEach(blog => {
        blog.tags.forEach(tag => {
            uniqueTagsSet.add(tag);
        });
        });

        const uniqueTagsArray = Array.from(uniqueTagsSet);
        setTags(uniqueTagsArray);
    }

    useEffect( () => {
        fetchTags();
    },[])

    return (
        <div className="container py-36 h-screen">
            <div className="flex flex-wrap justify-center mx-4 mb-8 gap-3 md:gap-6 md:mb-10 lg:gap-10">
                {tags.map((t) => 
                    <button key={t} className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === `${t}` ? activeClass : ""}`}
                    onClick={() => { setIsFilter(`${t}`); updateBlogCount(`${t}`); }}>{t}</button>
                )}
                
                {/* <button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "all" ? activeClass : ""}`}
                    onClick={() => { setIsFilter("all"); updateBlogCount("all"); }}>All</button>
                <button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "cloud" ? activeClass : ""}`}
                    onClick={() => { setIsFilter("cloud"); updateBlogCount("cloud"); }}>Cloud</button> */}
            </div>

            <div className="inline-block px-5 rounded-3xl uppercase bg-secondaryC text-shC mx-5 mb-7 dark:bg-dHeading dark:text-dHeadingC">
                <p>Blogs: {isblogCount}</p>
            </div>

            <div className=" pb-10 grid gap-10 grid-cols-3 grid-rows-1 text-primaryC px-5 sm:grid-cols-1 xll:grid-cols-2 md:grid-cols-1 md:gap-5">
                {Object.keys(blogData).filter(row => blogData[row].tags.includes(isFilter)).map((blog) => { 
                    return <BlogCard key={blogData[blog].title} title={blogData[blog].title} date={blogData[blog].date} content={blogData[blog].content} id={blogData[blog].id} imagepath={blogData[blog].imgpath} url={blogData[blog].url}/>;
                })}
            </div>
        </div>
    );
};

export default AllBlogs;